import { CreateAccountForm } from '@/app/(main)/_components/sign-in-modal/_components/register-form.component';
import { restApiClient } from '@/datasources';
import { formatBrDateToISO8601 } from '@/utils/formatters/format-br-date-to-iso-8601';
import { DocumentType } from '@/types/auth-base.types';
import { config } from '@/config/config';

export async function createAccount(formData: CreateAccountForm) {
  const route = 'v2/online/customers/with-email-validation/';

  const body = {
    birthday: formatBrDateToISO8601(formData.birthdate),
    contact: {
      email: formData.email,
      phones: [formData.cellphone],
    },
    customerAddress: {
      city: formData.city.split(' - ')[0],
      state: formData.city.split(' - ')[1],
    },
    documentNumber: formData.documentNumber,
    legalName: formData.legalName,
    socialName: formData.socialName,
    password: formData.password,
    passwordConfirmation: formData.password,
  };

  const url = `${config.restApi.url}/${route}`;

  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    throw new Error('Erro ao criar conta');
  }

  return response.json();
}

export async function checkIfCpfExists(cpf: string) {
  const { data } = await restApiClient.get<{ exists: boolean }>('public/user/exists-by', { cpf });
  return data;
}

export async function sendEmailValidationCode(pin: string, token: string) {
  const route = 'online/customers/email-validation/';
  const url = `${config.restApi.url}/${route}`;
  const body = {
    code: pin,
  };

  const header = {
    Authorization: `Bearer ${token}`,
  };

  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...header,
    },
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    throw new Error('Erro ao enviar código de validação');
  }

  return response.json();
}

export async function resendEmailValidationCode(documentNumber: string, token: string) {
  const route = 'online/customers/send-validation-code-for-registration';
  const url = `${config.restApi.url}/${route}`;
  const body = {
    documentNumber,
  };

  const header = {
    Authorization: `Bearer ${token}`,
  };

  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...header,
    },
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    throw new Error('Erro ao reenviar código de validação');
  }

  return response.json();
}

type Contact = {
  phones: string[];
  email: string;
};

type CompleteCustomerAccountAddress = {
  city: string;
  state: string;
};

export type CompleteCustomerAccountType = {
  documentType: DocumentType;
  customerAddress: CompleteCustomerAccountAddress;
  gender: string;
  contact: Contact;
  legalName: string;
  birthday: string;
  socialName?: string;
  documentNumber: string;
};

export async function completeCustomerAccount(data: CompleteCustomerAccountType) {
  await restApiClient.put('online/customers/complete-customer-account', data);
}
